const scope = "bookAnalytics";
export default scope;
